import React from "react";
import PropTypes from "prop-types";
import styles from "./PageHeader.module.css";
import HomeIcon from "../../Shared/HomeIcon";
import { ChevronLeft } from "react-ikonate";

/**
 * Interactive component. A header that appears on every page.
 * If the user is not on the main homepage,
 * there will be an arrow that redirects back to the homepage using React Router.
 */
export function PageHeader({ onClick, isHome }) {
  return (
    <>
      {isHome ? (
        <div className={styles.container}>
          <HomeIcon className={styles.homeIcon} />
          <h1 className={styles.feed}>Feed</h1>
        </div>
      ) : (
        <div className={styles.container}>
          <ChevronLeft className={styles.chevronBtn} onClick={onClick} />
          <HomeIcon />
          <h1 className={styles.feed}>Feed</h1>
        </div>
      )}
    </>
  );
}

PageHeader.propTypes = {
  /**
   * Function that directs the user to the homepage if they are not already there.
   */
  onClick: PropTypes.func,
  /**
   * Boolean that states whether the user is already on the homepage (feed) or not.
   */
  isHome: PropTypes.bool,
};
